import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import FilterCard from "./FilterCard";
import {
  getIsForeigner,
  getIsStudyingInEnglish,
  getIsBulgarianCitizen,
  setIsForeigner,
  setIsStudyingInEnglish,
  setIsBulgarianCitizen,
} from "../../services/students/studentsSlice";
import { Checkbox } from "primereact/checkbox";

const OtherFilter = () => {
  const isForeigner = useSelector(getIsForeigner);
  const isStudyingInEnglish = useSelector(getIsStudyingInEnglish);
  const isBulgarianCitizen = useSelector(getIsBulgarianCitizen);
  const dispatch = useAppDispatch();

  return (
    <FilterCard title="Други:">
      <div className="flex flex-col flex-wrap gap-3">
        <div className="flex align-items-center">
          <Checkbox
            inputId="isForeigner"
            checked={isForeigner}
            onChange={(e) => dispatch(setIsForeigner(e.checked || false))}
          />
          <label htmlFor="isForeigner" className="ml-2 cursor-pointer">
            Чуждестранни студенти
          </label>
        </div>
        <div className="flex align-items-center">
          <Checkbox
            inputId="isStudyingInEnglish"
            checked={isStudyingInEnglish}
            onChange={(e) => dispatch(setIsStudyingInEnglish(e.checked || false))}
          />
          <label htmlFor="isStudyingInEnglish" className="ml-2 cursor-pointer">
            Обучение на английски език
          </label>
        </div>
        <div className="flex align-items-center">
          <Checkbox
            inputId="isBulgarianCitizen"
            checked={isBulgarianCitizen}
            onChange={(e) => dispatch(setIsBulgarianCitizen(e.checked || false))}
          />
          <label htmlFor="isBulgarianCitizen" className="ml-2 cursor-pointer">
            Български граждани
          </label>
        </div>
      </div>
    </FilterCard>
  );
};

export default OtherFilter;
